<template>
  <div>
    <span
      v-for="tab in tabs"
      :key="tab.name"
      class="tab"
      :class="{active: tab.id === defaultId}"
      :style="{lineHeight: `${height}px`, fontSize: `${fontSize}px`}"
      :name="tab.id"
      @click="handleClickTab(tab.id)"
    >
      <i v-if="tab.isLoading" class="el-icon-loading"></i>
      {{ tab.name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default() {
        return []
      }
    },
    defaultId: {
      type: [String, Number, Boolean]
    },
    height: {
      type: Number,
      default: 40
    },
    fontSize: {
      type: Number,
      default: 14
    }
  },
  model: {
    prop: 'defaultId',
    event: 'change'
  },
  methods: {
    handleClickTab(id) {
      this.$emit('change', id)
      this.$emit('dlPortfolioId')
    }
  }
}
</script>

<style lang="scss" scoped>
.tab {
  font-weight: 600;
  color: $G9;
  display: inline-block;
  vertical-align: top;
  padding: 0 24px 0;
  text-align: center;
  cursor: pointer;
  &.active {
    color: $main-color;
      border-bottom: 2px solid $main-color;
  }
}
</style>
